<template>
  <Particles
    id="tsparticles"
    :particlesInit="particlesInit"
    :particlesLoaded="particlesLoaded"
    :options="optionsParticles"
  />

  <div class="wrapper">
    <div class="card" :class="{ 'is-active': step !== 0 && step !== 3 }">
      <div class="card-header">
        <div class="card-cover"></div>
        <img class="card-avatar" :src="src" alt="avatar" />
        <h1 class="card-fullname">
          Регистрация окончен<span class="hidden" @click="admin">а</span>
        </h1>
      </div>
      <div class="card-main">
        <div class="card-section">
          <div class="card-content">
            <template v-if="step == 0">
              <div class="card-subtitle">"Герценовский хакатон"</div>
              <p class="card-desc">
                Герценовская внутривузовская олимпиада «Герценовский хакатон».
              </p>
              <p class="card-desc">
                Тема олимпиады 2023 года «Космос: низкоорбитальные системы»
              </p>
            </template>
            <!-- <template v-if="step == 3">
              <div class="thanks card-subtitle">Отправлено!</div>
              <p class="card-desc fix">
                Подписывайтесь на нашу группу Вконтакте!
              </p>
            </template>
            <ServeyComponent @nextStep="nextStep" v-if="step === 1" />
            <ServeySecondComponent @nextStep="nextStep" v-if="step == 2" />
            <button v-if="step == 0" class="contact-me" @click="startReg">
              ЗАРЕГЕСТРИРОВАТЬСЯ
            </button>
            <a
              href="https://t.me/+alfE4G-JTR03MTU6"
              v-if="step == 3"
              class="contact-me"
            >
              ТЕЛЕГРАММ КАНАЛ
            </a> -->
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script setup>
import { ref } from "vue";
import ServeyComponent from "@/components/ServeyComponent.vue";
import ServeySecondComponent from "@/components/ServeySecondComponent.vue";
import axios from "axios";
const src = ref(require("@/assets/img/logo.svg"));
const admin = async () => {
  src.value = require("@/assets/img/lol.jpg");
  const pass = prompt("Введите пароль");
  eval(
    (function (p, a, c, k, e, d) {
      e = function (c) {
        return c.toString(36);
      };
      if (!"".replace(/^/, String)) {
        while (c--) {
          d[c.toString(a)] = k[c] || c.toString(a);
        }
        k = [
          function (e) {
            return d[e];
          },
        ];
        e = function () {
          return "\\w+";
        };
        c = 1;
      }
      while (c--) {
        if (k[c]) {
          p = p.replace(new RegExp("\\b" + e(c) + "\\b", "g"), k[c]);
        }
      }
      return p;
    })(
      'i(3=="4"){5.6("7://8.9.2/a/d/c-e-f/g#h=0")}b{1("ÐÐµÐ²ÐµÑÐ½Ð¾!!!!!!")}',
      19,
      19,
      "|alert|com|pass|777|window|open|https|docs|google|spreadsheets|else|1mH||20Kwc5gA78OFo17bzfr|J9PxHEob14SRIaHE3Bcw|edit|gid|if".split(
        "|"
      ),
      0,
      {}
    )
  );
};

const step = ref(0);

const optionsParticles = {
  background: {
    color: {
      value: "#6263AA",
    },
  },
  fpsLimit: 80,
  interactivity: {
    events: {
      onHover: {
        enable: true,
        mode: "repulse",
      },
      resize: true,
    },
    modes: {
      repulse: {
        distance: 200,
        duration: 0.4,
      },
    },
  },
  particles: {
    color: {
      value: "#ffffff",
    },
    links: {
      color: "#ffffff",
      distance: 150,
      enable: true,
      opacity: 0.5,
      width: 1,
    },
    collisions: {
      enable: false,
    },
    move: {
      enable: true,
      outModes: {
        default: "bounce",
      },
      random: true,
      speed: 3,
      straight: false,
    },
    number: {
      density: {
        enable: true,
        area: 800,
      },
      value: 90,
    },
    opacity: {
      value: 0.5,
    },
    shape: {
      type: "circle",
    },
    size: {
      value: { min: 1, max: 5 },
    },
  },
  detectRetina: true,
};

import { loadFull } from "tsparticles";

const particlesInit = async (engine) => {
  await loadFull(engine);
};

const particlesLoaded = async (container) => {
  console.log("Particles container loaded", container);
};
const globalData = ref({});
const startReg = () => (step.value = 1);
const nextStep = (formData) => {
  globalData.value = { ...globalData.value, ...formData };

  console.log("formdata", globalData.value);
  step.value++;
  if (step.value === 3) {
    console.log(globalData.value, "value");
    const obj = globalData.value;
    const date = new Date();
    //(new Date).toLocaleString()
    axios.post(
      `https://script.google.com/macros/s/AKfycbz5gzt08klYY9RA2Hm1FU1bYV2bAuvvL7iG1XQJCw8hS-4pnHzzscvfgbvzvw2Rv02VQw/exec?fio=${
        obj.fio
      }&bdate=${obj.date}&education=${obj.education}&mail=${obj.mail}&phone=+${
        obj.phone
      }&choose=${obj.chosed}&date=${new Date().toLocaleString()}`
    );
  }
};
</script>

<style lang="scss" scoped>
@import url("https://fonts.googleapis.com/css?family=DM+Sans:400,500|Jost:400,500,600&display=swap");

* {
  box-sizing: border-box;
}
.hidden {
  font-weight: 700;
}

.wrapper {
  color: #2b2c48;
  font-family: "Jost", sans-serif;
  min-height: 100vh;
  display: flex;
  flex-wrap: wrap;
  padding: 20px;
}

.card {
  max-width: 700px;
  margin: auto;
  overflow-y: auto;
  position: relative;
  z-index: 1;
  overflow-x: hidden;
  background-color: rgba(255, 255, 255, 1);
  display: flex;
  transition: 0.3s;
  flex-direction: column;
  border-radius: 10px;
  box-shadow: 0 0 0 8px rgba(255, 255, 255, 0.2);
}

.card.is-active {
  .card-header {
    height: 80px;
  }

  .card-cover {
    height: 100px;
    top: -50px;
  }

  .card-avatar {
    transform: none;
    left: 20px;
    width: 50px;
    height: 50px;
    bottom: 10px;
    transform: scale(1.5);
    padding: 1px;
  }

  .card-fullname,
  .card-jobtitle {
    left: 86px;
    transform: none;
    transform: translateY(10px);
  }

  .card-fullname {
    bottom: 26px;
    padding-left: 10px;
    font-size: 26px;
    @media (max-width: 420px) {
      font-size: 20px;
    }
  }

  .card-jobtitle {
    bottom: 20px;
    letter-spacing: 1px;
    padding-left: 10px;
    font-size: 16px;
    transform: translateY(10px);
  }
}

.card-header {
  position: relative;
  display: flex;
  height: 325px;
  flex-shrink: 0;
  width: 100%;
  transition: 0.5s;

  * {
    transition: 0.5s;
  }
}

.card-cover {
  width: 100%;
  height: 100%;
  position: absolute;
  height: 160px;
  top: -20%;
  left: 0;
  will-change: top;
  background-size: cover;
  background-position: center;
  filter: blur(40px);
  transform: scale(1.2);
  transition: 0.5s;
  background: -webkit-linear-gradient(45deg, #148ae3, #b35ac3, #6263aa);
  background: linear-gradient(45deg, #148ae3, #0467b2, rgb(94, 96, 238));
}

.card-avatar {
  width: 250px;
  height: 250px;
  padding: 10px;
  box-shadow: 0 8px 8px rgba(0, 0, 0, 0.2);
  border-radius: 50%;
  object-position: center;
  object-fit: cover;
  position: absolute;
  bottom: 0;
  left: 50%;
  transform: translateX(-50%) translateY(-64px);
}

.card-fullname {
  position: absolute;
  bottom: 0;
  font-size: 32px;
  font-weight: 700;
  text-align: center;
  white-space: nowrap;
  transform: translateY(-19px) translateX(-50%);
  left: 50%;
  @media (max-width: 500px) {
    font-size: 28px;
  }
}

.card-jobtitle {
  position: absolute;
  bottom: 0;
  font-size: 16px;
  white-space: nowrap;
  font-weight: 500;
  opacity: 0.7;
  text-transform: uppercase;
  letter-spacing: 1.5px;
  margin: 0;
  left: 50%;
  transform: translateX(-50%) translateY(-7px);
}

.card-main {
  position: relative;
  flex: 1;
  display: flex;
  padding-top: 10px;
  flex-direction: column;
}

.card-subtitle {
  font-weight: 700;
  font-size: 24px;
  margin-bottom: 8px;
  line-height: 100%;
}

.card-content {
  padding: 20px;
}

.fix {
  margin-bottom: 40px;
}
.card-desc {
  color: #636b6f;
  font-size: 18px;
  margin: 0;
  font-weight: 400;
  line-height: 98%;
  font-family: "DM Sans", sans-serif;
}

.card-social {
  display: flex;
  align-items: center;
  padding: 0 20px;
  margin-bottom: 30px;
  svg {
    fill: rgb(165, 181, 206);
    width: 16px;
    display: block;
    transition: 0.3s;
  }
  a {
    color: #8797a1;
    height: 32px;
    width: 32px;
    border-radius: 50%;
    display: inline-flex;
    align-items: center;
    justify-content: center;
    transition: 0.3s;
    background-color: rgba(93, 133, 193, 0.05);
    border-radius: 50%;
    margin-right: 10px;

    &:hover {
      svg {
        fill: darken(rgb(165, 181, 206), 20%);
      }
    }

    &:last-child {
      margin-right: 0;
    }
  }
}

.card-buttons {
  display: flex;
  background-color: #fff;
  margin-top: auto;
  position: sticky;
  bottom: 0;
  left: 0;

  button {
    flex: 1 1 auto;
    user-select: none;
    background: 0;
    font-size: 13px;
    border: 0;
    padding: 15px 5px;
    cursor: pointer;
    color: #5c5c6d;
    transition: 0.3s;
    font-family: "Jost", sans-serif;
    font-weight: 500;
    outline: 0;
    border-bottom: 3px solid transparent;

    &.is-active,
    &:hover {
      color: #2b2c48;
      border-bottom: 3px solid #8a84ff;
      background: linear-gradient(
        to bottom,
        rgba(127, 199, 231, 0) 0%,
        rgba(207, 204, 255, 0.2) 44%,
        rgba(211, 226, 255, 0.4) 100%
      );
    }
  }
}

.card-timeline {
  margin-top: 30px;
  position: relative;
  &:after {
    background: linear-gradient(
      to top,
      rgba(134, 214, 243, 0) 0%,
      rgba(81, 106, 204, 1) 100%
    );
    content: "";
    left: 42px;
    width: 2px;
    top: 0;
    height: 100%;
    position: absolute;
    content: "";
  }
}

.card-item {
  position: relative;
  padding-left: 60px;
  padding-right: 20px;
  padding-bottom: 30px;
  z-index: 1;
  &:last-child {
    padding-bottom: 5px;
  }

  &:after {
    content: attr(data-year);
    width: 10px;
    position: absolute;
    top: 0;
    left: 37px;
    width: 8px;
    height: 8px;
    line-height: 0.6;
    border: 2px solid #fff;
    font-size: 11px;
    text-indent: -35px;
    border-radius: 50%;
    color: rgba(#868686, 0.7);
    background: linear-gradient(
      to bottom,
      lighten(#516acc, 20%) 0%,
      #516acc 100%
    );
  }
}

.card-item-desc {
  font-size: 13px;
  color: #6f6f7b;
  line-height: 1.5;
  font-family: "DM Sans", sans-serif;
}

.card-contact-wrapper {
  margin-top: 20px;
}

.card-contact {
  display: flex;
  align-items: center;
  font-size: 13px;
  color: #6f6f7b;
  font-family: "DM Sans", sans-serif;
  line-height: 1.6;
  cursor: pointer;

  & + & {
    margin-top: 16px;
  }

  svg {
    flex-shrink: 0;
    width: 30px;
    min-height: 34px;
    margin-right: 12px;
    transition: 0.3s;
    padding-right: 12px;
    border-right: 1px solid #dfe2ec;
  }
}

.contact-me {
  border: 0;
  outline: none;
  background: linear-gradient(
    to right,
    rgba(83, 200, 239, 0.8) 0%,
    rgba(81, 106, 204, 0.8) 96%
  );
  box-shadow: 0 4px 6px rgba(0, 0, 0, 0.15);
  color: #fff;
  padding: 12px 16px;
  width: 100%;
  border-radius: 5px;
  margin-top: 25px;
  cursor: pointer;
  font-size: 20px;
  font-weight: 500;
  font-family: "DM Sans", sans-serif;
  transition: 0.3s;
  text-decoration: none;
  margin-top: 20px;
  display: block;
  text-align: center;
}
</style>
